import { makeStyles, InputBase } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  input: {
    color: theme.orange,
  },
  placeholder: {
    "&::placeholder": {
      fontStyle: "italic",
      fontSize: 16,
    },
  },
}));

const TextFieldNoBorder = (props) => {
  const classes = useStyles();
  return (
    <InputBase
      {...props}
      InputProps={{
        classes: { input: classes.input },
      }}
    />
  );
};

export default TextFieldNoBorder;
